import type { SessionPort } from "../../domain/ports/SessionPort";

const PURPOSES_REQUIRING_ACCESS_TOKEN = new Set([
  "RESET_TOTP",
  "CHANGE_PASSWORD",
]);

export const getBearerTokenForEmailOtp = (
  purpose: string,
  session: SessionPort,
): string | undefined => {
  if (purpose === "PASSWORD_RESET") {
    return undefined;
  }

  if (PURPOSES_REQUIRING_ACCESS_TOKEN.has(purpose)) {
    return session.getAccessToken() ?? undefined;
  }

  if (purpose === "LOGIN") {
    return session.getTempAccessToken() ?? undefined;
  }

  return session.getTempAccessToken() ?? session.getAccessToken() ?? undefined;
};
